/**
 * Client API centralisé : le frontend communique EXCLUSIVEMENT avec cette API
 * (jamais directement avec Google Sheets ou Google Apps Script).
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true, timeout: 45000 });

export default client;

export const authApi = {
  createSession: (sessionId) =>
    client.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } }),
  me: () => client.get("/auth/me"),
  logout: () => client.post("/auth/logout"),
};

export const dashboardApi = {
  getDashboard: (filters) => client.get("/dashboard", { params: filters }),
  getFindings: (filters) => client.get("/findings", { params: filters }),
  getActions: (filters) => client.get("/actions", { params: filters }),
  getCcv: (filters) => client.get("/ccv", { params: filters }),
  getPced: (filters) => client.get("/pced", { params: filters }),
  getAred: (filters) => client.get("/ared", { params: filters }),
  getAccidents: (filters) => client.get("/accidents", { params: filters }),
  getSiteProgress: (filters) => client.get("/site-progress", { params: filters }),
  getBogScore2026: (filters) => client.get("/bog-score-2026", { params: filters }),
  getShield: (filters) => client.get("/shield", { params: filters }),
  getHazid: (filters) => client.get("/hazid", { params: filters }),
  getTif: (filters) => client.get("/tif", { params: filters }),
  getVpc: (filters) => client.get("/vpc", { params: filters }),
  getTopRisques: (filters) => client.get("/top-risques", { params: filters }),
  getRanking: (filters) => client.get("/ranking", { params: filters }),
  getHeatmap: (filters) => client.get("/heatmap", { params: filters }),
  getFilterOptions: (params) => client.get("/filters/options", { params }),
  getFavoriteFilters: () => client.get("/preferences/favorite-filters"),
  saveFavoriteFilters: (filters) => client.put("/preferences/favorite-filters", filters),
  deleteFavoriteFilters: () => client.delete("/preferences/favorite-filters"),
};
